import { styled } from 'styled-components';

import { Divider } from './divider';
import { FormWrapper } from './styles';
import { FormProps } from './types';

const Form = ({ children, ...props }: FormProps) => {
  return <FormWrapper {...props}>{children}</FormWrapper>;
};
Form.Divider = Divider;
export default styled(Form)``;
